import { render, staticRenderFns } from "./GraduationDestination.vue?vue&type=template&id=68fc13d8&scoped=true"
import script from "./GraduationDestination.vue?vue&type=script&lang=js"
export * from "./GraduationDestination.vue?vue&type=script&lang=js"
import style0 from "./GraduationDestination.vue?vue&type=style&index=0&id=68fc13d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fc13d8",
  null
  
)

export default component.exports